const applyToTimeBuckets = Object.freeze({
  All: "All",
  Changed: "Changed",
});

export default applyToTimeBuckets;
